import React, { Component } from 'react';
import styleable from 'react-styleable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import SvgIcon from '../../components/svg-icon/svg-icon';
import PageButton from '../../components/page-button/page-button';
import IconButton from '../../components/icon-button/icon-button';
import css from './confirmation-modal.scss';
import { executeConfirmCommand, closeConfirmation } from './confirmation-modal-actions';
import Text from './confirmation-modal-text';


@styleable(css)
class ConfirmationModal extends Component {
    static propTypes = {
        executeConfirmCommand: PropTypes.func,
        closeConfirmation: PropTypes.func,
        confirmationModalState: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.handleDistributor = this.handleDistributor.bind(this);
        this.chooseStudentsBtns = [
            {
                label: 'Cancel',
                action: 'cancel',
                data: {}
            },
            {
                label: 'Move',
                action: 'move',
                toUrl: '/students',
                data: {}
            },
            {
                label: 'Copy',
                action: 'copy',
                data: {}
            }
        ];
        this.moveStudentsBtns = [
            {
                label: 'Cancel',
                action: 'cancel',
                data: {}
            },
            {
                label: 'Move',
                action: 'move',
                toUrl: '/students',
                data: {}
            }
        ];
        this.acceptCloseBtns = [
            {
                type: 'close',
                action: 'cancel',
                data: {}
            },
            {
                type: 'accept',
                action: 'unassign',
                data: {}
            }
        ];
        this.acceptCloseBtnsStudent = [
            {
                type: 'close',
                action: 'cancel',
                data: {}
            },
            {
                type: 'accept',
                action: 'unassign-student',
                data: {}
            }
        ];
        this.confirmBtns = [
            {
                label: 'Ok',
                action: 'ok',
                data: {}
            }
        ];
    }

    componentWillUpdate() {}

    componentDidMount() {}

    handleDistributor(item) {
        switch (item.action) {
        case 'cancel':
            this.props.closeConfirmation();
            break;
        case 'move':
            this.props.executeConfirmCommand('move');
            break;
        case 'copy':
            this.props.executeConfirmCommand('copy');
            break;
        case 'unassign':
            this.props.executeConfirmCommand('unassign');
            break;
        case 'unassign-student':
            this.props.executeConfirmCommand('unassign-student');
            break;
        case 'ok':
            this.props.closeConfirmation();
            break;
        default:
            this.props.closeConfirmation();
            break;
        }
    }

    render() {
        const { show, displayInfo /* , dismissManner */ } = this.props.confirmationModalState;
        const showModal = show ? 'showModal' : 'hideModal';

        // to be relaced by //  `global-theme-span ${css[disabled]} ${css[type]}`
        const globalThemeSpanClass = 'text';

        const iconShowClass = `${css.icon}`;
        const iconHiddenClass = `${css.icon} ${css['icon-hidden']}`;
        let iconTypeDom = (
            <div>
                <div className={iconShowClass}><SvgIcon type="warning" /></div>
                <div className={iconHiddenClass}><SvgIcon type="tick" /></div>
            </div>);

        if (displayInfo.type !== 'display-options' && displayInfo.type !== 'display-unassign' &&
            displayInfo.type !== 'display-unassign-student') {
            iconTypeDom = (
                <div>
                    <div className={iconHiddenClass}><SvgIcon type="warning" /></div>
                    <div className={iconShowClass}><SvgIcon type="tick" /></div>
                </div>);
        }

        let buttonsDoms;
        switch (displayInfo.type) {
        case 'display-options':
            buttonsDoms = pageButtons(this.chooseStudentsBtns, this.handleDistributor);
            break;
        case 'display-unassign':
            buttonsDoms = iconButtons(this.acceptCloseBtns, this.handleDistributor);
            break;
        case 'display-unassign-student':
            buttonsDoms = iconButtons(this.acceptCloseBtnsStudent, this.handleDistributor);
            break;
        case 'display-move':
            buttonsDoms = pageButtons(this.moveStudentsBtns, this.handleDistributor);
            break;
        case 'display-success-options':
        case 'display-success':
        case 'display-success-unassign':
        default:
            buttonsDoms = pageButtons(this.confirmBtns, this.handleDistributor);
            break;
        }

        let contentDoms;
        switch (displayInfo.type) {
        case 'display-options':
            contentDoms = moveOrCopyMessage(globalThemeSpanClass);
            break;
        case 'display-move':
            contentDoms = moveMessage(globalThemeSpanClass);
            break;
        case 'display-unassign':
            contentDoms = unassignStudentMessage(globalThemeSpanClass, displayInfo.bePlural);
            break;
        case 'display-unassign-student':
            contentDoms = unassignStudentMessage(globalThemeSpanClass, displayInfo.bePlural);
            break;
        case 'display-success':
            contentDoms = confirmUnassignedMessage(displayInfo.bePlural);
            break;
        case 'display-success-options':
            contentDoms = confirmMovedOrCopiedMessage(globalThemeSpanClass, displayInfo);
            break;
        case 'display-success-unassign':
            contentDoms = confirmUnassignedMessage(displayInfo.bePlural);
            break;
        default:
            contentDoms = (<div>Error!</div>);
            break;
        }

        return (
            <div className={`${css['confirmation-modal']} ${css[showModal]}`}>
                <div className={css['dialogue-box']}>
                    <div className={css.content}>
                        <div className={css.icon}>
                            {iconTypeDom}
                        </div>
                        {contentDoms}
                        <div className={css['buttons-holder']}>
                            { buttonsDoms }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function iconButtons(acceptCloseBtns, onClickHandler, acceptStatus) {
    const btnsDoms = acceptCloseBtns.map((item) => {
        const myAcceptStatus = item.type === 'close' ? 'enabled' : acceptStatus;
        return (
            <IconButton
                key={item.type}
                type={item.type}
                callback={() => onClickHandler(item)}
                enabled={myAcceptStatus || 'enabled'} />
        );
    });

    return btnsDoms;
}

function pageButtons(chooseStudentsBtns, onClickHandler) {
    const btnsDoms = chooseStudentsBtns.map(item =>
        (<PageButton key={item.label} onClick={() => onClickHandler(item)}>
            {Text[item.label]}
        </PageButton>)
    );

    return btnsDoms;
}

function unassignStudentMessage(globalThemeSpanClass, bePlural) {
    const stuText = bePlural ? 'students' : 'student';
    const stuInstructions = stuText.charAt(0).toUpperCase() + stuText.slice(1);
    const msgDom = (
        <div className={css.msg} >
            <div className={css['instruction-text']}>
                {Text.unassignMessages[`unassign${stuInstructions}`]}
            </div>
            <br />
            <div className={css['details-text']}>
                {Text.unassignMessages[stuText]}
                <span>&nbsp;</span>
                <span className={globalThemeSpanClass}>{Text.unassignMessages.unassigned}</span>
                <span>&nbsp;</span>
                {Text.unassignMessages.andMay}
            </div>
            <div className={css['details-text']}>
                {Text.unassignMessages.loseAccess}
            </div>
            <br />
            <div className={css['details-text']}>
                <span className={globalThemeSpanClass}>{Text.unassignMessages.continue}</span>
            </div>
        </div>
    );

    return msgDom;
}

function moveOrCopyMessage(globalThemeSpanClass) {
    const msgDom = (
        <div className={css.msg} >
            <div className={css['instruction-text']}>
                {Text.moveCopy.doYou}
                <span className={globalThemeSpanClass}> {Text.moveCopy.move} </span>
                {Text.moveCopy.or}
                <span className={globalThemeSpanClass}> {Text.moveCopy.copy} </span>
                {Text.moveCopy.selected}
            </div>
            <div className={css['comment-text']}>
                <span className={css['highlight-bold']}>{Text.Move}</span>
                {Text.moveCopy.currentClass}
            </div>
            <div className={css['comment-text']}>
                <span className={css['highlight-bold']}>{Text.Copy}</span>
                {Text.moveCopy.newClass}
            </div>
        </div>
    );

    return msgDom;
}

function moveMessage(globalThemeSpanClass) {
    return (
        <div className={css.msg} >
            <div className={css['instruction-text']}>
                {Text.moveCopy.doYou}
                <span className={globalThemeSpanClass}> {Text.moveCopy.move} </span>
                {Text.moveCopy.selected}
            </div>
            <div className={css['comment-text']}>
                <span className={css['highlight-bold']}>{Text.Move}</span>
                {Text.moveCopy.currentClass}
            </div>
        </div>
    );
}

function confirmMovedOrCopiedMessage(globalThemeSpanClass, displayInfo) {
    const type = displayInfo.choosedType;
    const studentNumber = type.students.length;
    const studentPlural = (studentNumber && studentNumber === 1) ? Text.confirm.Student : Text.confirm.Students;
    const moveCopy = type.action === 'move' ? 'moved' : 'copied';

    return (
        <div className={css.msg} >
            <div className={css['confirmation-text']}>
                {Text.confirm.youHave} {Text.confirm[moveCopy]}
                <span>&nbsp;</span>
                <span className={globalThemeSpanClass}>{studentNumber}&nbsp;{studentPlural}</span>
            </div>
        </div>
    );
}

function confirmUnassignedMessage(bePlural) {
    const stuText = bePlural ? 'Students' : 'Student';
    const hasText = bePlural ? 'have' : 'has';
    const msgDom = (
        <div className={css.msg} >
            <div className={css['confirmation-text']}>
                {Text.confirm[stuText]} {Text.confirm[hasText]} {Text.confirm.beenUnassigned}
            </div>
        </div>
    );

    return msgDom;
}
/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from MessageModalCombinedReducers.
 */
function mapStateToProps(state) {
    return {
        confirmationModalState: state.confirmationModalReducer
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        executeConfirmCommand,
        closeConfirmation
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationModal);



// WEBPACK FOOTER //
// ./containers/confirmation-modal/confirmation-modal.js